import { memo } from "react";

type Props = {
	children: React.ReactNode;
};

export const QuestionPlanDiscountConnectionRoot = memo(({ children }: Props) => {
	return (
		<div className="space-y-4">
			<div>
				<p className="text-sm text-brand">
					※
					「自動で適用されるディスカウント」を設定すると、このプランにおいてその他のディスカウントは適用できなくなります。
				</p>
			</div>

			{children}
		</div>
	);
});

QuestionPlanDiscountConnectionRoot.displayName = "QuestionPlanDiscountConnectionRoot";
